import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
}

const InstitutionalManagementModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    'primary.200',
    'primary.300',
    'primary.400',
    'primary.500',
    'primary.600',
    'primary.700',
    'primary.900',
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Login_Unificado" data-name="Login Unificado">
          <g>
            <path
              fill={fillColor200}
              opacity="0.2"
              d="M173.89,681.78S82,632,73,510,45.56,412,30.78,368s.78-149.33,72-178.67,179.55,27.11,248.89,24.89S479,143,556,152s157.11,58.78,180.56,128.89,11.11,171-30.23,203.55S601,534,579,556s-42.33,96.78-104.67,132.89S315.78,773.56,173.89,681.78Z"
            />
            <path
              fill={fillColor400}
              opacity="0.2"
              d="M453.52,344.35S478.21,284,546,301.21s80.84-23.84,128.11,13,56.06,94.52,37.57,125.67-35,21.42-42,75.79c-8.53,66.06-82,33.72-98.65-1.46-15.25-32.3-37.47-54.38-66.82-62.34C480,445.34,424.32,395.85,453.52,344.35Z"
            />
            <path
              fill={fillColor400}
              opacity="0.2"
              d="M442.18,729.59s-64.3-11-62.2-80.9S339.16,575,364.87,520.81s80.1-75.25,114.52-64,28.52,29.56,83.11,24.6c66.34-6,50.72,72.75,20,96.6-28.22,21.91-44.94,48.39-46.34,78.77C535,681.78,498.79,746.91,442.18,729.59Z"
            />
            <path
              fill={fillColor400}
              opacity="0.2"
              d="M154.33,334.22s-41.29-50.5,6.19-101.86S178.13,149.94,233.07,126s109.82-4.19,128.37,26.92,2.12,41,46.56,73.11c54,39-9.49,88.18-48.33,86C324,310,294,319,273,341,255.74,359.08,185.67,384.44,154.33,334.22Z"
            />
            <path
              fill={fillColor600}
              d="M762.09,567.69c-16.41,8.85-32.38.2-37.19-15.41-4.55-13.88-1.76-41.63,12.55-47.3,14.56-5.77,32.36,14.9,36.21,29.9a35.21,35.21,0,0,1-3.74,25.94A23.75,23.75,0,0,1,762.09,567.69Z"
            />
            <path
              fill={fillColor600}
              d="M474.85,98.94c-1.08,18.56-20.14,27-37.19,29.57-1.88.28-3.71,1.07-5.49,1.33a7.86,7.86,0,0,1-8.62-4.12,34.66,34.66,0,0,1-1.86-5.57c-6.37-21.06-3.27-50.85,22.15-52.79,14-1.6,26.7,9.84,30.3,22.59A44.44,44.44,0,0,1,474.85,98.94Z"
            />
            <path
              fill={fillColor600}
              d="M99.68,707.54c-.58,3.66-3.36,6.8-6.49,8.78l-.1.06c-7.82,4.07-17.47,2.35-24.52-2.72a53.21,53.21,0,0,1-21.19-41.19c-.14-4.63,1-10.21,7.07-13.28a13.42,13.42,0,0,1,4.21-1.47C71.31,655.55,102.5,689.8,99.68,707.54Z"
            />
            <path
              fill={fillColor600}
              d="M70.78,605.33S19,524,55,435s84.11-83.13,138.56-112.57,66.66-114.76,170.55-141.1,175.22,15.78,219.56,54.23,70.58,91.33,72.46,159.88S662.67,466,690.33,520,673,630.33,653,650.67s-58.44,46.55-118.22,36.44S424.93,639.42,388,637c-61-4-95,46-146,47S132.56,685.67,70.78,605.33Z"
            />
          </g>
          <g>
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M454.11,207.66l16.43,5.47a36.89,36.89,0,0,1,25.23,35v23.6a36.86,36.86,0,0,0,36.09,36.87l23.62.51a36.85,36.85,0,0,1,32.19,20.38l7.76,15.5a36.88,36.88,0,0,1-6.91,42.57l-16.69,16.69a36.89,36.89,0,0,0-.56,51.59l16.35,17.08A36.85,36.85,0,0,1,596,510.08l-5.47,16.44a36.9,36.9,0,0,1-35,25.23h-23.6A36.85,36.85,0,0,0,495,587.83l-.51,23.63a36.86,36.86,0,0,1-20.38,32.19l-15.5,7.75a36.88,36.88,0,0,1-42.57-6.9l-16.69-16.69a36.89,36.89,0,0,0-51.59-.57l-17.08,16.35a36.86,36.86,0,0,1-37.18,8.35l-16.44-5.47a36.9,36.9,0,0,1-25.23-35V587.89A36.85,36.85,0,0,0,215.79,551l-23.63-.51A36.88,36.88,0,0,1,160,530.13l-7.75-15.51a36.85,36.85,0,0,1,6.91-42.56l16.68-16.69a36.89,36.89,0,0,0,.57-51.59L160,386.7a36.9,36.9,0,0,1-8.38-37.22l5.47-16.43a36.91,36.91,0,0,1,35-25.23H215.7a36.86,36.86,0,0,0,36.88-36.08l.5-23.63a37,37,0,0,1,20.41-32.19L289,208.17a36.86,36.86,0,0,1,42.57,6.9l16.68,16.69a36.89,36.89,0,0,0,51.59.57L416.93,216A36.89,36.89,0,0,1,454.11,207.66Z"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillColor600}
              d="M423.63,380A70.48,70.48,0,1,1,324,380a70.48,70.48,0,0,1,99.67,0"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(InstitutionalManagementModuleBrand)
